import React from 'react';
import CategoryPill from 'src/components/CategoryPill/CategoryPill';
import { IWalkthroughModel } from 'src/services/client-types';
import { variables } from 'src/Tenants';
import calcomLogo from 'src/pages/Calendar/CalcomIntegration/calcom-logo.svg';
import './WalkthroughSummaryItem.scss';

interface IWalkthroughSummaryItemProps {
  walkthrough: IWalkthroughModel;
  index: number;
  isCalcomConnected?: boolean;
}

const WalkthroughSummaryItem = ({
  walkthrough,
  index,
  isCalcomConnected = false,
}: IWalkthroughSummaryItemProps) => {
  const suiteName: string = variables.Suite;

  // Todo: hotfix client side to show better copy for this pill. Should probably be changed from the API upstream.
  const displayStatus: string =
    walkthrough.status === 'Activate'
      ? 'Pending Activation'
      : walkthrough.status;

  return (
    <div className="walkthrough-summary-item">
      <div className="walkthrough-item-header">
        <div className="walkthrough-item-number">#{index + 1}</div>
        <div className="walkthrough-item-details">
          <h4 className="walkthrough-item-title">{walkthrough.title}</h4>
          <p className="walkthrough-item-description">
            {walkthrough.description}
          </p>
        </div>

        <div className="walkthrough-item-meta">
          <CategoryPill
            text={displayStatus}
            color="#6b7280"
            textColor="white"
            size="normal"
            centerText
          />
          <CategoryPill
            text={walkthrough.walkthroughType}
            color="#9ca3af"
            textColor="white"
            size="normal"
            centerText
          />
          {walkthrough.isEmailSent && (
            <CategoryPill
              text="Email Sent"
              color="#10B981"
              textColor="white"
              size="normal"
              centerText
            />
          )}
          {walkthrough.isEmailSent && isCalcomConnected && (
            <span className="calcom-link-pill">
              <img
                src={calcomLogo}
                className="calcom-link-pill-logo"
                alt="Cal.com"
              />
              scheduling link sent
            </span>
          )}
        </div>
      </div>

      <div className="walkthrough-item-info-grid">
        <div className="walkthrough-item-info-item">
          <span className="walkthrough-item-label">Permissions:</span>
          <span className="walkthrough-item-value">
            {walkthrough.permissions}
          </span>
        </div>
        <div className="walkthrough-item-info-item">
          <span className="walkthrough-item-label">{suiteName} Number:</span>
          <span className="walkthrough-item-value">
            {walkthrough.suiteName}
          </span>
        </div>
        <div className="walkthrough-item-info-item">
          <span className="walkthrough-item-label">Checklist Items:</span>
          <span className="walkthrough-item-value">
            {walkthrough.walkthroughChecklistItems?.length || 0}
          </span>
        </div>
        {walkthrough.recipientEmail && (
          <div className="walkthrough-item-info-item">
            <span className="walkthrough-item-label">Recipient Email:</span>
            <span className="walkthrough-item-value walkthrough-item-value--email">
              {walkthrough.recipientEmail}
            </span>
          </div>
        )}
      </div>

      {walkthrough.walkthroughChecklistItems &&
        walkthrough.walkthroughChecklistItems.length > 0 && (
          <div className="walkthrough-item-checklist">
            <h5>Checklist Items:</h5>
            <ul>
              {walkthrough.walkthroughChecklistItems.map((item) => (
                <li key={item.id}>{item.description}</li>
              ))}
            </ul>
          </div>
        )}
    </div>
  );
};

export default WalkthroughSummaryItem;
